import styled, { css } from 'styled-components';


export const StepsAnswer = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.fontColors.textColor};
  margin-left: 50px;
  margin-top: 15px;
  margin-right: 50px;
  @media only screen and (min-width: 1375px) {
    margin-right: 147px;
  }
  @media only screen and (max-width: 767px) {
    margin-left: 20px;
    font-size: ${props => props.theme.fontSize.secondary};
  }
  @media only screen and (max-width: 480px) {
    margin-left: 20px;
    margin-right: 20px;
    overflow-wrap: break-word !important;
  }
  &.stepAnswers ul li, &.stepAnswers ol li {
    font-family: ${props => props.theme.fontFamily.berkeleyStd};
  }
`;